import { ReactNode } from 'react';

const RootContainer = ({ children }: { children: ReactNode }) => {
  return <div className='relative overflow-x-hidden -mt-12'>{children}</div>;
};

export default RootContainer;
